import React, { createRef } from "react";
import Label from "../../../components/Label/Label";
import {
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  Tooltip,
  Input,
  InputAdornment,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import Carousel from "react-multi-carousel";
import PdfICon from "../../../components/Icons/PdfIcon";
import MapToolBar from "../../../components/MapData/MapToolBar";
import PrismaZoom from "react-prismazoom";
import ImageMapper from "react-img-mapper";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as acts from "../../../redux/processor/actions";
import AngleArrowLeft from "../../../assets/svg/angle-circle-left-icon.svg";
import AngleArrowRight from "../../../assets/svg/angle-circle-right-icon.svg";
import "./mapData.scss";
import "./imageViewer.scss";
import "react-image-crop/dist/ReactCrop.css";
import TabelSelections from "../../pre_processor/MapData/TabelSelections";
import SearchIcon from "@mui/icons-material/Search";
//import LazyLoad from "react-lazyload";
import CropFreeIcon from "@mui/icons-material/CropFree";

const CustomLeftArrow = ({ onClick }) => (
  <button
    onClick={() => onClick()}
    className="slick-prev"
    variant="contained"
    size="medium"
    color="primary"
  >
    Prev
  </button>
);
const CustomRightArrow = ({ onClick }) => {
  return (
    <button
      className="slick-next"
      onClick={() => onClick()}
      variant="contained"
      size="medium"
      color="primary"
    >
      Next
    </button>
  );
};

class ImageViewer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedFile: {
        tagName: null,
        fileNo: null, // index is considered as file
        pageNo: null,
      },

      zoom: 1,
      prismaZoom: React.createRef(),
      allowZoom: true,
      responsive: {
        superLargeDesktop: {
          // the naming can be any, depends on you.
          breakpoint: { max: 4000, min: 3000 },
          items: 5,
        },
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 3,
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 2,
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1,
        },
      },
      pageRotateAngle: 0,
      imageLoaded: false,
      selectedArea: {},
      data: [],
      entireCoorDataFromPageState: [],
      originalMapperWidth: 600,
      originalMapperHeight: 768,
      imageMapperWidth: 600,
      imageMapperHeight: 768,
      tableSelection: false,

      openPopover: false,
      selectionType: "coords",
      imageLoadedInDiv: false,
      firstCoordinateToAutoScroll: [],
    };
    // Create the child instance using react createRef
    this.child = React.createRef();
    this.checkIsImageLoadable = this.checkIsImageLoadable.bind(this);
    this.changeRef = createRef(); // Create a ref object for the child component
    // this.refreshRef = createRef(); // Create a ref object for the child component
  }

  componentDidMount() {
    this.props.acts.clearApiStatus();
    this.props.acts.setSelectedFileDataForProUpdateMapping({});
  }

  // UNSAFE_componentWillReceiveProps(nextProps) {
  //   // used this to set first pdf selected in initial state  and temp setting some initialn data
  //   if (nextProps?.coorData.length > 0) {
  //     const initialFileIndex = 0;

  //     if (
  //       Object.values(this?.state?.selectedFile).every(
  //         (x) => x === null || x === ""
  //       )
  //     ) {
  //       this.setState({
  //         selectedFile: {
  //           tagName: nextProps?.coorData[0]?.pdfName,
  //           fileNo: 0,
  //           pageNo: 0,
  //         },
  //       });
  //       this.setState({
  //         data: { ...nextProps?.coorData[0]?.pages[0] },
  //         entireCoorDataFromPageState: [...nextProps?.coorData],
  //       }); // initial page setting
  //       this.setState({ imageLoaded: false });
  //       this.checkIsImageLoadable(initialFileIndex, 0); // the second argument is current page number
  //     }

  //     if (nextProps?.coorData?.length) {
  //       // let sortedCoorData = nextProps?.coorData;

  //       // sortedCoorData.map((fileData, index) => {
  //       //   const sortedPagesData = fileData.pages.sort((a, b) => {
  //       //     return parseInt(a.pageNo) - parseInt(b.pageNo);
  //       //   });
  //       //   sortedCoorData[index]["pages"] = sortedPagesData;
  //       // });

  //       // this.setState({ data: { ...sortedCoorData[0]?.pages[0] } }); // initial page setting
  //       this.setState({ data: { ...nextProps?.coorData[0]?.pages[0] } }); // initial page setting
  //       this.props.acts.setSelectedFileDataForProUpdateMapping({
  //         tagName: nextProps?.coorData[0]?.pdfName,
  //         fileNo: 0,
  //         pageNo: 0,
  //       });
  //     }
  //   }

  //   if (
  //     nextProps?.pdfAndPageDetails &&
  //     Object.keys(nextProps?.pdfAndPageDetails).length !== 0
  //   ) {
  //     let dataToSet = {
  //       ...this?.state?.entireCoorDataFromPageState[
  //         nextProps?.pdfAndPageDetails?.fileNo
  //       ]?.pages[nextProps?.pdfAndPageDetails?.pageNo],
  //     };

  //     if (
  //       this.state.selectedFile.tagName !==
  //         nextProps?.pdfAndPageDetails?.tagName ||
  //       this.state.selectedFile.fileNo !==
  //         nextProps?.pdfAndPageDetails?.fileNo ||
  //       this.state.selectedFile.pageNo !== nextProps?.pdfAndPageDetails?.pageNo
  //     ) {
  //       this.setState({ imageLoaded: false });
  //       this.checkIsImageLoadable(
  //         nextProps?.pdfAndPageDetails?.fileNo,
  //         nextProps?.pdfAndPageDetails?.pageNo
  //       )
  //         .then(() => {
  //           // Call another function after checkIsImageLoadable completes
  //           const delay = true;
  //           // this.autoScrollTOCoordinate( // no needed in qc 2.o for now in future release may be
  //           //   delay,
  //           //   dataToSet?.width,
  //           //   dataToSet?.height
  //           // );
  //         })
  //         .catch((error) => {
  //           console.error("Error in checkIsImageLoadable:", error);
  //         });

  //       this.setState({
  //         selectedFile: {
  //           // ...this.state.selectedFile,
  //           tagName: nextProps?.pdfAndPageDetails?.tagName,
  //           fileNo: nextProps?.pdfAndPageDetails?.fileNo,
  //           pageNo: parseInt(nextProps?.pdfAndPageDetails?.pageNo),
  //         },
  //         pageRotateAngle: 0,
  //       });
  //     } else {
  //       const delay = false;
  //       // this.autoScrollTOCoordinate(delay, dataToSet?.width, dataToSet?.height);
  //     }

  //     this.setState({
  //       selectionType: "coords",
  //     });

  //     if (Object.keys(dataToSet).length !== 0) {
  //       let newAreas = [];
  //       nextProps?.pdfAndPageDetails?.coordinates?.map(
  //         (coords, indexOfCoodinates) => {
  //           const newAreaObj = {
  //             shape: "rect",
  //             coords: coords,
  //             preFillColor: "#ff00002e",
  //             fillColor: "#ff00002e",
  //           };
  //           newAreas.push(newAreaObj);
  //         }
  //       );

  //       this.setState({
  //         data: { ...dataToSet, areas: [...dataToSet?.areas, ...newAreas] },
  //         firstCoordinateToAutoScroll:
  //           nextProps?.pdfAndPageDetails?.coordinates &&
  //           nextProps?.pdfAndPageDetails?.coordinates?.length > 0
  //             ? nextProps?.pdfAndPageDetails?.coordinates[0]
  //             : null,
  //       });
  //     }
  //   }
  // }

  componentDidUpdate(prevProps) {
    const { coorData, pdfAndPageDetails } = this.props;
    // Handle initial data setup
    if (coorData && coorData.length > 0) {
      const initialFileIndex = 0;

      // Check if the selectedFile is empty or not set yet
      if (
        Object.values(this.state.selectedFile).every(
          (x) => x === null || x === "",
        )
      ) {
        const initialData = {
          selectedFile: {
            tagName: coorData[0]?.pdfName,
            fileNo: 0,
            pageNo: 0,
          },
          data: { ...coorData[0]?.pages[0] },
          entireCoorDataFromPageState: [...coorData],
          imageLoaded: false,
        };

        this.setState(initialData);
        this.checkIsImageLoadable(initialFileIndex, 0);
        this.props.acts.setSelectedFileDataForProUpdateMapping(
          initialData.selectedFile,
        );
      }
    }

    // Update data when pdfAndPageDetails changes
    if (
      pdfAndPageDetails &&
      Object.keys(pdfAndPageDetails).length !== 0 &&
      pdfAndPageDetails !== prevProps.pdfAndPageDetails
    ) {
      const { fileNo, pageNo, tagName, coordinates } = pdfAndPageDetails;
      const dataToSet =
        coorData[pdfAndPageDetails.fileNo]?.pages[pdfAndPageDetails.pageNo];

      const pageData =
        this.state.entireCoorDataFromPageState[fileNo]?.pages[pageNo] || {};

      if (
        this.state.selectedFile.tagName !== tagName ||
        this.state.selectedFile.fileNo !== fileNo ||
        this.state.selectedFile.pageNo !== pageNo
      ) {
        this.setState({ imageLoaded: false });
        this.checkIsImageLoadable(fileNo, pageNo)
          .then(() => {
            // Future auto-scroll functionality can be added here
            const delay = true;
            this.autoScrollTOCoordinate(
              delay,
              dataToSet?.width,
              dataToSet?.height,
            );
          })
          .catch((error) => {
            console.error("Error in checkIsImageLoadable:", error);
          });

        this.setState({
          selectedFile: {
            tagName,
            fileNo,
            pageNo: parseInt(pageNo, 10),
          },
          pageRotateAngle: 0,
          selectionType: "coords",
        });
      } else {
        const delay = false;
        this.autoScrollTOCoordinate(delay, dataToSet?.width, dataToSet?.height);
      }
      // Update areas with new coordinates, if available
      if (Object.keys(pageData).length !== 0) {
        // const newAreas = Array.isArray(coordinates)
        //   ? coordinates.map((coords) => ({
        //       shape: "rect",
        //       coords,
        //       preFillColor: "#ff00002e",
        //       fillColor: "#ff00002e",
        //     }))
        //   : [];

        this.setState({
          data: {
            ...pageData,
            areas: [
              ...(pageData.areas || []),
              // , ...newAreas
            ],
          },
          firstCoordinateToAutoScroll: coordinates?.[0] || null,
        });
      }
    }
  }

  clicked = (area, index, e) => {
    this.setState({
      selectedArea: area,
    });

    const dataToUpdate = this.state.data;
    dataToUpdate.areas[index] = {
      ...this.state.data.areas[index],
      preFillColor: "#ff00002e",
      fillColor: "#ff00002e",
    };
    this.setState({
      data: { ...dataToUpdate },
    });
    this.props.acts.setOCRValue(area?.name, area?.coords);
  };

  onClickedFromTableSelection = (area, index, e) => {
    this.setState({
      selectedArea: area,
      areaIndex: index,
    });
    this.props.acts.setOCRValue(area?.name, area?.coords);
  };

  checkIsImageLoadable = (fileIndex, pageNo) => {
    return new Promise((resolve, reject) => {
      if (this.props?.coorData[fileIndex]?.pages[pageNo]?.imageUrl) {
        const objImg = new Image();
        objImg.src = this.props?.coorData[fileIndex]?.pages[pageNo]?.imageUrl;
        objImg.onload = () => {
          this.setState({ imageLoaded: true });
          resolve(); // Resolve the promise when image loads successfully
        };
        objImg.onerror = () => {
          this.setState({ imageLoaded: false });
          resolve(); // Resolve the promise when image loads successfully
        };
      } else {
        this.setState({ imageLoaded: false });
        resolve(); // Resolve the promise when image loads successfully
      }
    });
  };

  fitToScreenClick = () => {
    // Safely reset prismaZoom if it exists
    if (this.state.prismaZoom?.current) {
      this.state.prismaZoom.current.reset();
    }
    this.setState({
      pageRotateAngle: 0,
      imageMapperWidth: this?.state?.originalMapperWidth,
      imageMapperHeight: this?.state?.originalMapperHeight,
    });
  };

  rotateClick = (value) => {
    if (value === "right") {
      this.setState({ pageRotateAngle: this.state.pageRotateAngle + 90 });
    }
    if (value === "left") {
      this.setState({ pageRotateAngle: this.state.pageRotateAngle - 90 });
    }
  };

  onZoomChange = (zoom) => {
    this.setState({
      zoom: zoom,
    });
  };

  onClickZoom = (value) => {
    if (value === "out") {
      // Safely reset prismaZoom if it exists
      if (this.state.prismaZoom?.current) {
        this.state.prismaZoom.current.zoomOut(1);
      }
    } else {
      if (this.state.prismaZoom?.current) {
        this.state.prismaZoom.current.zoomIn(1);
      }
    }
  };

  searchPageClick = (value) => {
    if (
      value <
        this.props?.coorData[this.state.selectedFile?.fileNo].pages.length &&
      value >= 0
    ) {
      this.setState({
        selectedFile: {
          ...this.state.selectedFile,
          pageNo: Number(value),
        },
        pageRotateAngle: 0,
        data: this.props?.coorData[this.state?.selectedFile?.fileNo]?.pages[
          Number(value)
        ],
        imageMapperWidth: this?.state?.originalMapperWidth,
        imageMapperHeight: this?.state?.originalMapperHeight,
      });

      // Safely reset prismaZoom if it exists
      if (this.state.prismaZoom?.current) {
        this.state.prismaZoom.current.reset();
      }
      this.setState({ imageLoaded: false });
      this.checkIsImageLoadable(this.state.selectedFile.fileNo, Number(value));
      this.props.acts.setSelectedFileDataForProUpdateMapping({
        ...this.state.selectedFile,
        pageNo: Number(value),
      });
    }

    this.setState({ selectionType: "coords" });
    this?.state?.selectionType !== "coords" &&
      this.changeRef.current.onChangePdforPageWhenTableSelectin(); // Call the child function through the ref
  };

  handlePageChange = (value) => {
    if (value === "prev" && parseInt(this.state.selectedFile?.pageNo) !== 0) {
      const prevPageNo = parseInt(this.state.selectedFile?.pageNo) - 1;
      this.setState({
        selectedFile: {
          ...this.state.selectedFile,
          pageNo: prevPageNo,
        },
        pageRotateAngle: 0,
        data: this.props?.coorData[this.state?.selectedFile?.fileNo]?.pages[
          prevPageNo
        ],
      });

      // Safely reset prismaZoom if it exists
      if (this.state.prismaZoom?.current) {
        this.state.prismaZoom.current.reset();
      }
      this.setState({ imageLoaded: false });
      this.checkIsImageLoadable(this.state.selectedFile.fileNo, prevPageNo);
      this.props.acts.setSelectedFileDataForProUpdateMapping({
        ...this.state.selectedFile,
        pageNo: prevPageNo,
      });
    } else if (value === "next") {
      const nextPageNo = parseInt(this.state.selectedFile?.pageNo) + 1;

      this.setState({
        selectedFile: {
          ...this.state.selectedFile,
          pageNo: nextPageNo,
        },
        pageRotateAngle: 0,
        data: this.props?.coorData[this.state?.selectedFile?.fileNo]?.pages[
          nextPageNo
        ],
      });

      // Safely reset prismaZoom if it exists
      if (this.state.prismaZoom?.current) {
        this.state.prismaZoom.current.reset();
      }
      this.setState({ imageLoaded: false });
      this.checkIsImageLoadable(this.state.selectedFile.fileNo, nextPageNo);
      this.props.acts.setSelectedFileDataForProUpdateMapping({
        ...this.state.selectedFile,
        pageNo: nextPageNo,
      });
    }
    this.setState({
      imageMapperWidth: this?.state?.originalMapperWidth,
      imageMapperHeight: this?.state?.originalMapperHeight,
    });

    this.setState({ selectionType: "coords" });
    this?.state?.selectionType !== "coords" &&
      this.changeRef.current.onChangePdforPageWhenTableSelectin(); // Call the child function through the ref
  };

  handleFileChange(tagName, index) {
    this.setState({
      selectedFile: {
        tagName: tagName,
        fileNo: index,
        pageNo: 0,
      },
      pageRotateAngle: 0,
      data: this?.props?.coorData[index]?.pages[0],
      imageMapperWidth: this?.state?.originalMapperWidth,
      imageMapperHeight: this?.state?.originalMapperHeight,
    });
    // Safely reset prismaZoom if it exists
    if (this.state.prismaZoom?.current) {
      this.state.prismaZoom.current.reset();
    }
    this.setState({ imageLoaded: false });
    this.checkIsImageLoadable(index, 0);
    this.props.acts.setSelectedFileDataForProUpdateMapping({
      tagName: tagName,
      fileNo: index,
      pageNo: 0,
    });

    this.setState({ selectionType: "coords" });
    this?.state?.selectionType !== "coords" &&
      this.changeRef.current.onChangePdforPageWhenTableSelectin(); // Call the child function through the ref
  }

  onClickCellToRedirect = (tagName, pageNo, fileNo) => {
    if (tagName && !isNaN(pageNo) && !isNaN(fileNo)) {
      this.setState({
        selectedFile: {
          tagName: tagName,
          fileNo: fileNo,
          pageNo: pageNo,
        },
        pageRotateAngle: 0,
        data: this?.props?.coorData[fileNo]?.pages[pageNo],
      });
    }

    // Safely reset prismaZoom if it exists
    if (this.state.prismaZoom?.current) {
      this.state.prismaZoom.current.reset();
    }
    this.setState({ imageLoaded: false });
    this.checkIsImageLoadable(fileNo, 0);
  };

  onClickChangeOrientation = () => {
    this.setState({
      imageMapperWidth: this?.state?.imageMapperHeight,
      imageMapperHeight: this?.state?.imageMapperWidth,
    });
  };

  cropCompleted = (c, p) => {
    if (c.height && c.width) {
      let tableArea = {
        coords: c,
        name: "Table Selection",
        tableSelection: true,
      };
      this.setState({
        selectedArea: tableArea,
        // areaIndex: index,
      });
      this.setState({ openPopover: true });
    }
  };

  handleClose = () => {
    this.setState({ openPopover: false });
  };

  handleChange = (event) => {
    this?.setState({
      selectionType: event.target.value,
    });
  };

  // refresh = (e) => {
  //   this.refreshRef.current.refreshSelection(); // Call the child function through the ref
  // };
  // handleImageLoad = () => {
  //   console.log("sdd");
  //   // this.setState({ imageLoadedInDiv: true });
  // };

  handleKeyDown = (e) => {
    if (e.key === "Enter") {
      this.searchPageClick(this.state.inputValue - 1);
    }
  };

  autoScrollTOCoordinate = (delay, resolutionWidth, resolutionHeight) => {
    resolutionWidth &&
      resolutionHeight &&
      setTimeout(
        () => {
          // Original and resized image dimensions
          const originalWidth = resolutionWidth;
          const originalHeight = resolutionHeight;
          const resizedWidth = this?.state?.imageMapperWidth;
          const resizedHeight = this?.state?.imageMapperHeight;

          // Calculate scaling factors
          const widthScalingFactor = resizedWidth / originalWidth;
          const heightScalingFactor = resizedHeight / originalHeight;

          // Get coordinates from state
          const coordinates = this.state?.firstCoordinateToAutoScroll;

          // Apply scaling to coordinates if they exist
          const scaledX = coordinates ? coordinates[0] * widthScalingFactor : 0;
          const scaledY = coordinates
            ? coordinates[1] * heightScalingFactor
            : 0;

          // Adjust for scrolling 100 is just gap from top and left
          const scrollTop = scaledY > 50 ? scaledY - 50 : 0;
          const scrollLeft = scaledX > 50 ? scaledX - 50 : 0;

          // Perform the scrolling
          // document.getElementById("ImageIdAutoScroll").scrollTo({
          //   top: scrollTop,
          //   left: scrollLeft,
          //   behavior: "smooth",
          // });

          const element = document.getElementById("ImageIdAutoScroll");
          if (element) {
            element.scrollTo({
              top: scrollTop,
              left: scrollLeft,
              behavior: "smooth",
            });
          } else {
            console.error("Element with ID 'ImageIdAutoScroll' not found.");
          }
        },
        delay ? 1000 : 0,
      );
  };

  onSubmitCrop = ({ selectedArea }) => {
    if (!selectedArea || !selectedArea.width || !selectedArea.height) return;

    const { data, imageMapperWidth, imageMapperHeight } = this.state;

    const origW = data?.width || imageMapperWidth;
    const origH = data?.height || imageMapperHeight;

    // selectedArea here is in the CHILD's "original/unrotated" coordinate
    // space, which — since the aspect-ratio fix — is the LETTERBOXED box
    // that preserves the real image's aspect ratio inside
    // imageMapperWidth x imageMapperHeight, not that raw box itself. We have
    // to recompute that same letterboxed box here so we scale against the
    // correct dimensions. This MUST mirror TabelSelections' safeBaseDims
    // calculation exactly, or the two will drift out of sync again.
    const srcRatio = origW / origH;
    const boxRatio = imageMapperWidth / imageMapperHeight;
    const baseW =
      srcRatio > boxRatio
        ? imageMapperWidth
        : Math.round(imageMapperHeight * srcRatio);
    const baseH =
      srcRatio > boxRatio
        ? Math.round(imageMapperWidth / srcRatio)
        : imageMapperHeight;

    // Because this box preserves aspect ratio (letterboxed, not stretched),
    // there is only ONE correct scale factor — x and y scale identically.
    const scale = origW / baseW; // equivalently origH / baseH

    const x1 = Math.round(selectedArea.x * scale);
    const y1 = Math.round(selectedArea.y * scale);
    const x2 = Math.round((selectedArea.x + selectedArea.width) * scale);
    const y2 = Math.round((selectedArea.y + selectedArea.height) * scale);

    this.props.acts.setBboxFromDraw({
      bBoxCoords: [x1, y1, x2, y2],
    });
  };

  handleInlineMapOpen = (type) => {
    this.setState((prev) => ({
      selectionType: prev.selectionType === type ? "coords" : type,
    }));
  };

  render() {
    return (
      // <Box className={this?.props?.isFullView ? "container-2" : "container-1"}>
      <Box className={"container-1"}>
        <Grid className="imageview-header">
          <Grid item xs={8}>
            <div className="ac-processor-pdf-slider-body">
              <section>
                <div>
                  <Carousel
                    ssr
                    //partialVisible
                    deviceType={this.props.deviceType}
                    itemClass="image-item"
                    responsive={this.state.responsive}
                    customRightArrow={<CustomRightArrow />}
                    customLeftArrow={<CustomLeftArrow />}
                  >
                    {this.props?.coorData?.map((file, index) => {
                      const label = file.pdfName;
                      const truncatedLabel =
                        label.length > 6 ? label.slice(0, 6) + "..." : label;
                      const tooltipLabel = label.length > 6 ? label : "";
                      return (
                        <div
                          className="ac-processor-slider-content"
                          onClick={() =>
                            this.handleFileChange(file.pdfName, index)
                          }
                        >
                          <PdfICon
                            fillColor={
                              this.state.selectedFile?.fileNo === index
                                ? "#E52222"
                                : "#5d5d5d"
                            }
                            // height={
                            //   this.state.selectedFile?.fileNo === index
                            //     ? "25px"
                            //     : "25px"
                            // }
                            // width={
                            //   this.state.selectedFile?.fileNo === index
                            //     ? "25px"
                            //     : "25px"
                            // }
                          />

                          <Tooltip title={tooltipLabel}>
                            <Typography
                              sx={{ marginLeft: "4px" }}
                              variant="caption"
                              display="block"
                            >
                              {truncatedLabel}
                            </Typography>
                          </Tooltip>
                        </div>
                      );
                    })}
                  </Carousel>
                </div>
              </section>
            </div>
          </Grid>
          <Grid item xs={6} className="angle-arrow-grid" spacing={1}>
            {/* {this.props?.is_template_uploaded === false && ( */}
            {/* <Tooltip title="Selection Type" arrow placement="top">
              <FormControl
                variant="standard"
                size="small"
              >
                <div className="img-select">
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={this?.state?.selectionType}
                    onChange={this?.handleChange}
                  >
                    <MenuItem value={"coords"}>Words</MenuItem>
                    <MenuItem value={"page"}>Sentence</MenuItem>
                  </Select>
                </div>
              </FormControl>
            </Tooltip> */}

            {/* <MuiTooltip
              title={isExpanded ? "Collapse" : iconLabel}
              placement="bottom"
              arrow
            > */}
            {/* <span
              style={{
                // position: "absolute", // ✅ key
                // bottom: "4px", // adjust as needed
                // right: "6px", // adjust as needed
                cursor: "pointer",
                // display: "inline-flex",
                color:
                  this?.state?.selectionType === "drawBbox"
                    ? "rgb(76 212 38)"
                    : "",
                transition: "color 0.15s",
                // opacity: cellDisabled ? 0.55 : 1,
                // zIndex: 2, // ensure above textarea
              }}
              onClick={(e) => {
                e.stopPropagation();
                // if (cellDisabled) return;
                this.handleInlineMapOpen("drawBbox");
              }}
              onMouseEnter={(e) => {
                // if (!cellDisabled) e.currentTarget.style.color = "#616161";
              }}
              onMouseLeave={(e) => {
                // if (!cellDisabled) e.currentTarget.style.color = "#9e9e9e";
              }}
            >
              <CropFreeIcon sx={{ fontSize: 13 }} />
            </span> */}
            {/* </MuiTooltip> */}
            {/* )} */}

            <div>
              <FormControl className="page-N" variant="standard">
                <Input
                  className="p-0"
                  type="number"
                  id="standard-adornment-password"
                  onKeyDown={this.handleKeyDown} // Add the event listener here
                  onChange={(e) =>
                    this.setState({ inputValue: e.target.value })
                  }
                  placeholder="Page"
                  endAdornment={
                    <InputAdornment
                      position="end"
                      className="search-icon"
                      size="small"
                    >
                      <IconButton
                        className="p-2"
                        size="small"
                        aria-label="toggle password visibility"
                        onClick={() =>
                          this.searchPageClick(this.state.inputValue - 1)
                        }
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
            </div>

            <div className="angle-container">
              <div className="angle-arrow-display">
                <IconButton
                  className={
                    parseInt(this.state.selectedFile?.pageNo) + 1 <= 1
                      ? "arrow-angle-condition"
                      : "arrow-angle-condition2"
                  }
                  // disabled={true}
                  onClick={(e) =>
                    parseInt(this.state.selectedFile?.pageNo) !== 0 &&
                    this?.handlePageChange("prev")
                  }
                >
                  <img
                    className="angle-arrow-left"
                    src={AngleArrowLeft}
                    alt="prev page"
                  />
                </IconButton>

                <IconButton
                  className={
                    parseInt(this.state.selectedFile?.pageNo) + 1 >=
                    this.props?.coorData[this.state.selectedFile?.fileNo]?.pages
                      ?.length
                      ? "arrow-angle-condition"
                      : "arrow-angle-condition2"
                  }
                  onClick={(e) =>
                    parseInt(this.state.selectedFile?.pageNo) + 1 !==
                      this.props?.coorData[this.state.selectedFile?.fileNo]
                        ?.pages?.length && this?.handlePageChange("next")
                  }
                >
                  <img
                    className="angle-arrow-right"
                    src={AngleArrowRight}
                    alt="next page"
                  />
                </IconButton>
              </div>

              <>
                <h1 className="angle-arrow-text">{`Page ${
                  parseInt(this.state.selectedFile?.pageNo) + 1
                }/ ${
                  this.props?.coorData[this.state.selectedFile?.fileNo]?.pages
                    ?.length
                }`}</h1>
              </>
            </div>

            <MapToolBar
              file={this.props?.coorData[this.state.selectedFile?.fileNo]}
              handlePageChange={this.handlePageChange}
              selectedFile={this.state.selectedFile}
              searchPageClick={this.searchPageClick}
              onClickZoom={this.onClickZoom}
              zoom={this.state.zoom}
              rotateClick={this.rotateClick}
              fitToScreenClick={this.fitToScreenClick}
              onClickChangeOrientation={this.onClickChangeOrientation}
            />
          </Grid>
        </Grid>
        <Grid className="view_pdf_new" md={12} id="ImageIdAutoScroll">
          {this.state?.imageLoaded ? (
            <PrismaZoom
              minZoom={1}
              maxZoom={10}
              animDuration={0.5}
              allowZoom={this.state.allowZoom}
              ref={this.state.prismaZoom}
              onZoomChange={this.onZoomChange}
            >
              {/* // this.state.tableSelection ? ( */}
              {/* {this?.state?.selectionType === "table" ||
              this?.state?.selectionType === "page" ||
              this?.state?.selectionType === "drawBbox" ? ( */}
              <TabelSelections
                imageData={this?.state?.data}
                selectionType={this?.state?.selectionType}
                imageMapperWidth={this?.state?.imageMapperWidth}
                imageMapperHeight={this?.state?.imageMapperHeight}
                onClicked={(area, index, e) =>
                  this.onClickedFromTableSelection(area, index, e)
                }
                ref={this.changeRef}
                // ref2={this.refreshRef}
                pageRotateAngle={this?.state?.pageRotateAngle}
                onSubmitCrop={this.onSubmitCrop}
                pdfAndPageDetails={this.props?.pdfAndPageDetails}
                currentPageNo={this?.state?.selectedFile?.pageNo} // ← ADD THIS
                currentFileNo={this?.state?.selectedFile?.fileNo} // ← ADD THIS
              />
              {/* ) : (
                <div
                  id="container"
                  style={{
                    transform: `rotate(${this.state.pageRotateAngle}deg)`,
                    transition: "transform 150ms ease", // smooth transition
                    cursor: "default",
                    left: [
                      90, 270, 450, 630, 810, 990, 1170, 1350, 1530, 1710, 1890,
                    ].includes(this.state.pageRotateAngle)
                      ? "14%"
                      : 0,
                    position: "relative",
                  }}
                >
                  <>
                  
                    <ImageMapper
                      src={this.state?.data?.imageUrl}
                      map={this.state?.data}
                      // width={600}
                      // height={768}
                      width={this?.state?.imageMapperWidth}
                      height={this?.state?.imageMapperHeight}
                      onClick={(area, index, e) => this.clicked(area, index, e)}
                      imgWidth={this?.state?.imageMapperWidth}
                      natural={true}
                      responsive={true}
                      parentWidth={this?.state?.imageMapperWidth}
                      disabled={this?.props?.disabled}
                    />
                   
                  </>
                </div>
              )} */}
            </PrismaZoom>
          ) : (
            <Box className="imageView-progressbar-div">
              <CircularProgress color="primary" size={40} thickness={4} />
              <Label
                text=" Loading..."
                fontSize="16px"
                paddingLeft="20px"
              ></Label>
            </Box>
          )}
        </Grid>
      </Box>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    acts: bindActionCreators(acts, dispatch),
  };
};

function mapStateToProps(state) {
  return {
    coorData: state.pro?.coorData?.coordinatesDetails || [],
    apiStatus: state.pro?.apiStatus,
    pdfAndPageDetails: state.pro?.pdfAndPageDetails,
    cellData: state.pro?.cellData,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ImageViewer);
